/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import {
  IDataPullSection,
  IDataPullSectionMapping,
  IDataPullSectionMappingField
} from '../../../interfaces/pull-data-group.interface';

@Component({
  selector: 'xilo-mono-form-viewer-selection-modal',
  templateUrl: './selection-modal.component.html',
  styleUrls: ['./selection-modal.component.scss']
})
export class SelectionModalComponent implements OnInit {
  sections: IDataPullSection[] = [];

  constructor(
    public dialogRef: MatDialogRef<SelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.sections = this.data.sections;
  }

  saveData() {
    this.dialogRef.close({
      success: true,
      data: this.sections
    });
  }

  closeModal(): void {
    this.dialogRef.close({ success: false });
  }

  mergeDuplicateRecord(group: IDataPullSectionMapping): void {
    group.isDuplicate = true;
    group.isValid = true;
  }

  unselectRecord(group: IDataPullSectionMapping): void {
    // Unselect the checkbox
    group.isValid = false;
    // Close the accordion
    group.isOpen = false;
    group.isDuplicate = false;
  }

  selectAll(group: IDataPullSectionMapping, value: boolean) {
    group.values = group.values.map((g) => {
      g.isValid = value;
      return g;
    });
  }

  removeItem(field: IDataPullSectionMappingField, group: IDataPullSectionMapping) {
    field.isValid = false;
    group.isValid = group.values.some((v) => v.isValid);
  }

  addItem(field: IDataPullSectionMappingField, group: IDataPullSectionMapping) {
    field.isValid = true;
    group.isValid = true;
  }
}
